<template>
  <div>
    <h1>Welcome to EZsign</h1>

    <div class="card">
      <h5 class="card-header">API & documentation</h5>
      <div class="card-body">
        <h2>your API key is <code>{{ api_key }}</code></h2>
        You may find the API documentation
        <a href="https://documenter.getpostman.com/view/16363118/UVyn2eCE" target="_blank">here</a>
        the documentation includes also code samples in the next languages:
        <ul>
          <li>C#</li>
          <li>Java</li>
          <li>Node.js</li>
          <li>PHP</li>
          <li>Curl as a bash\cmd command</li>
        </ul>
      </div>
    </div>

    <div class="card mt-3">
      <h5 class="card-header">Demo: sign PDF file manually</h5>
      <div class="card-body">
        <div class="alert alert-info" v-if="signaturesArr.length==0">
          In order to sign a PDF you must create at least one signature, <a href="#/backoffice/signatures">click
          here</a>
          or navigate to signatures in the menu
        </div>
        <div class="row" v-if="signaturesArr.length>0">
          <div class="col-sm-6">
            <ValidationObserver ref="form">
              <form role="form" name="signForm" id="signForm">
                <h3>Signing details</h3>
                <div class="form-group">
                  <label><span class="text-danger">*</span> Use signature: <span
                      class="text-warning">{{ sig_token }}</span></label>
                  <select class="form-control" v-model="sig_token">
                    <option v-for="signature in signaturesArr" v-bind:value="signature._id" :key="signature.id">
                      {{ signature.organization }}
                    </option>

                  </select>
                </div>
                <div class="form-group">
                  <label><span class="text-danger">*</span> Pdf file</label>
                  <input type="file" name="pdf_file" id="pdf_file" class="form-control" accept="application/pdf"
                         @change="loadPdfFile" @click="resetPdfFile">
                </div>
                <div class="form-group">
                  <label>Signer name</label>
                  <input type="text" name="name" id="name" v-model="signForm.name" class="form-control"
                         placeholder="John Due" value=""
                         required>
                </div>
                <div class="form-group">
                  <label>Reason</label>
                  <input type="text" name="reason" id="reason" v-model="signForm.reason" class="form-control"
                         placeholder="Formal invoice of EZcount" required>
                </div>
                <div class="form-group">
                  <label>Location</label>
                  <input type="text" name="location" id="location" v-model="signForm.location" class="form-control"
                         placeholder="Tel Aviv or www.ezcount.co.il" required>
                </div>


                <div v-show="advancedForm">
                  <div class="form-group">
                    <label>Password</label>
                    <input type="text" name="password" id="password" v-model="signForm.password" class="form-control"
                           placeholder="leave empty if no password specified">
                    <span class="form-text">you need to specify password only if you had created a signature with password</span>
                  </div>
                  <h3>Seal logo appearance</h3>
                  <validation-provider rules="numeric" v-slot="{errors,classes }">
                    <div class="form-group">
                      <label>Seal position X</label>
                      <input type="number" name="sealLogoX" id="sealLogoX" v-model="signForm.sealLogoX"
                             class="form-control"
                             placeholder="default is 25 points" :class="classes">
                      <div class="invalid-feedback">{{ errors[0] }}</div>
                      <span class="form-text">the location of the signature seal on the document</span>
                    </div>
                  </validation-provider>
                  <validation-provider rules="numeric" v-slot="{errors,classes }">
                    <div class="form-group">
                      <label>Seal position Y</label>
                      <input type="number" name="sealLogoY" id="sealLogoY" v-model="signForm.sealLogoY"
                             class="form-control"
                             placeholder="default is 25 points" :class="classes">
                      <div class="invalid-feedback">{{ errors[0] }}</div>
                      <span class="form-text">the location of the signature seal on the document</span>
                    </div>
                  </validation-provider>
                  <validation-provider rules="numeric" v-slot="{errors,classes }">
                    <div class="form-group">
                      <label>seal ZOOM</label>
                      <input type="number" name="sealLogoZoom" id="sealLogoZoom" v-model="signForm.sealLogoZoom"
                             class="form-control"
                             placeholder="default is -75" :class="classes">
                      <div class="invalid-feedback">{{ errors[0] }}</div>
                      <span class="form-text">the size of the signature seal on the document,<br/>
							the zoom function is: logoSize * sealLogoZoom / 100 <br/>
							so please use minus (-) in order to shrink it,</span>
                    </div>
                  </validation-provider>
                  <div class="form-group">
                    <label>seal image en</label>
                    <input type="checkbox" name="signImgEn" id="signImgEn" v-model="signForm.signImgEn"
                           class="ml-2">
                  </div>

                  <h3>Send PDF by email</h3>
                  <div>
                    <validation-provider rules="email" v-slot="{errors,classes }">
                      <div class="form-group">
                        <label>Email PDF: client email</label>
                        <input type="email" name="emailData_clientEmail" id="emailData_clientEmail"
                               v-model="signForm.emailData.clientEmail"
                               class="form-control"
                               placeholder="user@example.com" :class="classes">
                        <div class="invalid-feedback">{{ errors[0] }}</div>
                        <span class="form-text">if you will add this field we will send email to the client with the PDF
                        <b class="text-danger">this may add additional charges!</b>
                      </span>
                      </div>
                    </validation-provider>
                    <validation-provider rules="" v-slot="{errors,classes }">
                      <div class="form-group">
                        <label>Email PDF: client name</label>
                        <input type="text" name="emailData_clientName" id="emailData_clientName"
                               v-model="signForm.emailData.clientName"
                               class="form-control"
                               placeholder="John Due" :class="classes">
                        <div class="invalid-feedback">{{ errors[0] }}</div>
                      </div>
                    </validation-provider>
                    <validation-provider rules="" v-slot="{errors,classes }">
                      <div class="form-group">
                        <label>Email PDF: attachment file name</label>
                        <input type="text" name="emailData_attachmentFileName" id="emailData_attachmentFileName"
                               v-model="signForm.emailData.attachmentFileName"
                               class="form-control"
                               placeholder="attachment.pdf" :class="classes">
                        <div class="invalid-feedback">{{ errors[0] }}</div>
                        <span class="form-text">the name of the file as appear in the email client, if this field will be empty we will call it "attachment.pdf"</span>
                      </div>
                    </validation-provider>

                  </div>
                </div>
                <a href="javascript:void(0);"
                   v-on:click="advancedForm=!advancedForm">{{ advancedForm ? 'Hide' : 'Show' }}
                  advanced form</a>
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm-6 col-sm-offset-3">
                      <input type="button" class="form-control btn btn-primary" value="Sign this PDF"
                             v-on:click="signPdf()" :disabled="pdfFileLoading">
                    </div>
                  </div>
                </div>

              </form>
            </ValidationObserver>
          </div>
          <div class="col-sm-6">
            <h3>Console</h3>
            <div class="card mt-3">
              <h5 class="card-header">Request</h5>
              <div class="card-body">

                <code>
                  <pre>POST {{ signUrl }}<span class="text-warning">{{ sig_token }}</span>?api_key=<span
                      class="text-danger">{{ api_key }}</span></pre>
                </code>
                <code>
                  <pre>Content-Type: application/json</pre>
                </code>
                <pre>{{ signFormComputed }}</pre>
              </div>
            </div>
            <div class="card mt-3">
              <h5 class="card-header">Response</h5>
              <div class="card-body" :class='{
							"text-success": sign_success && sign_progress=="FINISH",
							"text-warning": !sign_success && sign_progress=="FINISH",
						}'>
                <div v-if="sign_progress=='START'">Please choose a PDF file and send it to the server</div>
                <div v-show="sign_progress=='UPLOADING'">Sending file to sign server</div>
                <div v-show="sign_success && sign_progress=='FINISH'">
                  <h4 class="mt-1">Success</h4>
                  <pre>{{ responseJSON }}</pre>
                  <div class="mt-1">
                    PDF successfully signed - open it in Acrobat reader to see the signature.
                    <a :href="downloadHref" download="response.pdf">download as PDF file</a>
                  </div>
                </div>
                <div v-show="!sign_success && sign_progress=='FINISH'">
                  <h4>Failed</h4>
                  <pre>{{ responseJSON }}</pre>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "../../../libs/ApiService";
import _ from "lodash";

const signUrl = '/private/sign/';

export default {
  name: "Dashboard",
  data() {
    return {
      api_key: this.$store.state.me.user.api_key,
      signForm: {
        name: null,
        reason: null,
        location: null,
        password: null,
        sealLogoX: null,
        sealLogoY: null,
        sealLogoZoom: null,
        pdf_file: null,
        signImgEn: false,
        emailData: {
          clientEmail: null,
          clientName: null,
          attachmentFileName: null
        }
      },
      advancedForm: false,
      signaturesArr: [],
      downloadHref: '',
      responseJSON: null,
      sig_token: '',
      sign_success: false,
      sign_progress: "START",
      pdfFileLoading: false,
      signUrl
    }
  },
  computed: {
    signFormComputed() {
      let copy = _.cloneDeep(this.signForm);
      // remove empty values
      // https://stackoverflow.com/a/33432857/2992810
      copy.emailData = _.pickBy(copy.emailData, _.identity);
      //if not set at all
      if (Object.keys(copy.emailData).length == 0) {
        delete copy.emailData;
      }
      copy = _.pickBy(copy, _.identity);
      return JSON.stringify(copy, null, 4);
    }
  },
  async created() {
    let {data} = await ApiService.get('/private/signatures');
    this.signaturesArr = data;
    this.sig_token = this.signaturesArr[0]._id;
  },
  methods: {
    resetPdfFile() {
      this.signForm.pdf_file = null;
    },
    async loadPdfFile() {
      // https://stackoverflow.com/a/46639837/2992810
      function getFileBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          if (file.name.split('.').pop().toLowerCase() != 'pdf') {
            //fix validation here...
            throw new Error("NOT A PDF!");
          }
          reader.readAsDataURL(file);

          reader.onload = () => {
            // we get the data here as  data:application/pdf;base64,JVBERi0xLjc...
            let dataAsUrlEncoded = reader.result;
            // strip out the data:application/pdf;base64,
            let base64Only = dataAsUrlEncoded.replace(/^.*,/, '')
            resolve(base64Only);
          }
          reader.onerror = error => reject(error);
        });
      }

      let file = document.querySelector('#signForm input#pdf_file[type="file"]').files[0];
      //convert to base64
      let base64file = await getFileBase64(file);
      this.signForm.pdf_file = base64file;
    },
    async signPdf() {
      //trigger validation
      if (!await this.$refs.form.validate()) {
        return;
      }

      if (!this.signForm.pdf_file) {
        return alert("please select a PDF file");
      }

      this.sign_progress = "UPLOADING";

      let res;
      try {
        res = await ApiService.post('/private/sign/' + this.sig_token, this.signForm);
      } catch (axiosErrorObj) {
        this.sign_success = false;
        res = axiosErrorObj.response;
      }
      //finish
      this.sign_progress = "FINISH";
      this.responseJSON = res.data;
      //failed
      if (res.data.success) {
        //success
        this.sign_success = true;
        this.downloadHref = 'data:application/pdf;base64,' + res.data.file_signed;
      }
    }
  }
}
</script>

<style scoped>

</style>